import React from "react";
import get from "lodash/get";
import { SocialShare } from "@quintype/components";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import humanizeDate from "../../utils/time-format";
import { StickySocialShareTemplate } from "./../sticky-social-share";
import { StoryHeader } from "../story-header";
import { AuthorDetails } from "../author-details";
import { StoryCard } from "../story-card";
import { StoryTags } from "../story-tag";
import { MostPopular } from "../most-popular";
import { ClockIcon } from "../../basic/icons/clock-icon";
import { MetypeCommentWrapper } from "../../metype-comments";
import { ColombiaAdWrapper } from "../../colombia-story";
import { CardShareTemplate } from "./card-share";
import { DfpAd } from "../../dfp-ad/";
import { EngagementCount } from "../../basic/engagement-count";
import { DFPAdsHorizontal } from "../../dfp-ad-horizontal";
import "./liveblog.m.css";

export class LiveBlogTemplate extends React.Component {
  constructor() {
    super();
    this.state = {
      renderMetype: false,
      renderColombia: false
    };
  }

  componentDidMount() {
    const cardId = this.props.cardId;
    if (cardId) {
      setTimeout(function() {
        document.getElementById(cardId) &&
          document.getElementById(cardId).scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
          });
      }, 1000);
    }
    this.setState({
      renderMetype: true
    });
    this.setState({
      cardsCount: this.props.story.cards.length,
      story: this.props.story
    });
    this.storyUpdate = setInterval(this.updateStory.bind(this), 30000);
  }

  componentWillUnmount() {
    if (this.storyUpdate) {
      clearInterval(this.storyUpdate);
    }
  }

  async updateStory() {
    const response = await window.fetch(`/api/v1/stories/${this.props.story.id}`);
    const jsonResponse = await response.json();
    this.setState({
      cardsCount: jsonResponse.story.cards.length,
      story: jsonResponse.story
    });
  }

  liveblogData(data) {
    return (
      data &&
      data.cards.map((card, index) => (
        <React.Fragment key={card.id}>
          <div className="story-cards" id={card.id} key={index}>
            <div styleName="show-time">
              <div styleName="published-time">
                <span styleName="clock-icon">
                  <ClockIcon color={this.props.color} />
                </span>{" "}
                <span styleName="time">{humanizeDate(card["card-added-at"])}</span>
              </div>
              <SocialShare
                template={CardShareTemplate}
                title={card.metadata["social-share"].title || data.headline}
                url={data && data.slug + "?cardId=" + card.id}
                color="#333"
                styleName="share-icon"
              />
            </div>

            <StoryCard key={card.id} card={card} story={data} />
          </div>
          {index !== 0 && index % 2 === 0 && <DFPAdsHorizontal />}
        </React.Fragment>
      ))
    );
  }

  render() {
    const langClassName = this.props.publisherAttributes.lang === "ur" ? "urdu-liveblog" : "liveblog";
    const author = {
      name: get(this.props.story, ["authors", 0, "name"], this.props.story["author-name"]),
      id: get(this.props.story, ["authors", 0, "id"], this.props.story["author-id"]),
      twitter: get(this.props.story, ["authors", 0, "twitter-handle"]),
      avatarUrl: get(this.props.story, ["authors", 0, "avatar-url"]),
      slug: get(this.props.story, ["authors", 0, "slug"])
    };
    return (
      <div styleName={langClassName}>
        <div>
          {!this.state.cardsCount ? (
            <StoryHeader story={this.props.story} showHeroImage iconLiveBlogClass="liveblog" />
          ) : (
            <StoryHeader story={this.state.story} showHeroImage iconLiveBlogClass="liveblog" />
          )}
          <div styleName="story-body">
            <SocialShare
              template={StickySocialShareTemplate}
              title={this.state.story && this.state.story.headline}
              url={this.state.story && this.state.story.slug}
              color="#fff"
            />
            <div styleName="story-content">
              <div styleName="author-wrapper">
                <div>
                  <AuthorDetails
                    author={author}
                    storyFirstPublishedDate={this.props.story["first-published-at"]}
                    storyLastPublishedDate={this.props.story["last-published-at"]}
                  />
                </div>
                <EngagementCount storyId={this.props.story.id} />
              </div>

              {!this.state.cardsCount ? this.liveblogData(this.props.story) : this.liveblogData(this.state.story)}
              {!this.state.cardsCount ? (
                <StoryTags tags={this.props.story && this.props.story.tags} />
              ) : (
                <StoryTags tags={this.state.story && this.state.story.tags} />
              )}
              <span>
                {this.state.story && this.state.story["first-published-at"] !== this.state.story["last-published-at"]
                  ? `Published: ${humanizeDate(this.state.story["first-published-at"])}`
                  : null}
              </span>
            </div>
          </div>
          <DFPAdsHorizontal />
          {this.state.renderMetype && (
            <MetypeCommentWrapper metypeConfig={this.props.metypeConfig} story={this.state.story} />
          )}
          <ColombiaAdWrapper />
        </div>

        <div>
          <div styleName="dfp">
            <DfpAd adtype="NH_300x250" />
          </div>
          <MostPopular mostPopular={this.props.mostPopular} id={this.state.story && this.state.story.id} hideIcon />
          <div styleName="dfp">
            <DfpAd adtype="NH_MP_300x600" />
          </div>
        </div>
      </div>
    );
  }
}
function LiveBlogStoryBase(props) {
  return (
    <div className="story-grid">
      <LiveBlogTemplate {...props} />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], [])
  };
}

LiveBlogTemplate.propTypes = {
  mostPopular: PropTypes.Array,
  color: PropTypes.string,
  cardId: PropTypes.string,
  cardsCount: PropTypes.number,
  story: PropTypes.shape({
    "author-name": PropTypes.string,
    "author-id": PropTypes.number,
    headline: PropTypes.string,
    slug: PropTypes.string,
    "first-published-at": PropTypes.number,
    "last-published-at": PropTypes.number,
    cards: PropTypes.Array,
    tags: PropTypes.Array,
    id: PropTypes.string
  }),
  metypeConfig: PropTypes.object,
  publisherAttributes: PropTypes.object
};
LiveBlogStoryBase.propTypes = {
  story: PropTypes.object,
  mostPopular: PropTypes.Array,
  metypeConfig: PropTypes.object
};

export const LiveBlogStory = connect(
  mapStateToProps,
  null
)(LiveBlogStoryBase);
